import type {NamedSetState} from 'app/gemStore/devtools';

import type {PrintingSlice} from './types';

export const createPrintingSlice = (set: NamedSetState<PrintingSlice>) => ({
    printing: false,
    setPrinting: (printing: boolean) => set({printing}, false, 'printing/setPrinting'),
});
